import { Outlet } from "react-router-dom";

import { SectionHeader, type SectionTab } from "../components/SectionHeader.js";

/**
 * `/tester` — the capability-testing shell.
 *
 * Three tabs:
 *   - **Run** (`/tester/run`)     — pick a target + service + channels + a
 *                                   destination phone and fire a live test.
 *   - **Servers** (`/tester/servers`) — register target servers + their API
 *                                   keys (the config the runner uses).
 *   - **History** (`/tester/runs`) — past runs and their outcomes.
 *
 * The shell is gated on `tester:view` (route guard in App.tsx). The
 * fire-the-test action and all target mutations gate additionally on
 * `tester:run` inside the pages. See docs/tester.md.
 */
const TABS: SectionTab[] = [
  { to: "run", label: "Run" },
  { to: "servers", label: "Servers" },
  { to: "runs", label: "History" },
];

export function TesterLayout(): JSX.Element {
  return (
    <>
      <SectionHeader
        title="Tester"
        subtitle="Point the test runner at one of your servers and exercise its value-added services — voice, SMS, WhatsApp and more — end to end."
        tabs={TABS}
        tabsAriaLabel="Tester sections"
      />
      <Outlet />
    </>
  );
}
